module.exports = __webpack_public_path__ + "static/media/Swedish Dysmate final report_compressed (1).417ee593.pdf";